// @flow
import { call, fork, put, take } from 'redux-saga/effects'
import { GET_RESOURCES_DASHBOARD, getResourcesDashboard } from 'src/redux/actions/resourcesDashboard/resourcesDashboard'
import http from 'src/services/http'
import { showToast } from 'src/redux/actions/ui/ui'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetResourcesDashboard(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_RESOURCES_DASHBOARD.REQUEST)

    try {
      const { data } = yield call(http, 'api/resource', {
        method: 'GET',
      })

      yield put(getResourcesDashboard.success(data))
    } catch (e) {
      yield put(getResourcesDashboard.error(e.message))
      yield put(showToast.success({ title: e.message, messageType: 'error' }))
    }
  }
}

export default [
  fork(watchGetResourcesDashboard),
]
